/* ═══════ LCL HOMEPAGE JS ═══════ */

/* ─── Hero Particle Canvas ─── */
(function() {
  var canvas = document.getElementById('heroCanvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var w, h, particles, mouse = { x: -1000, y: -1000 };
  var PARTICLE_COUNT = 80;

  function resize() { w = canvas.width = canvas.offsetWidth; h = canvas.height = canvas.offsetHeight; }

  function init() {
    resize();
    particles = [];
    for (var i = 0; i < PARTICLE_COUNT; i++) {
      particles.push({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.8 + 0.3,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        baseAlpha: Math.random() * 0.4 + 0.1,
        pulse: Math.random() * Math.PI * 2,
        pulseSpeed: Math.random() * 0.02 + 0.005
      });
    }
  }

  if (canvas.parentElement) {
    canvas.parentElement.addEventListener('mousemove', function(e) {
      var rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left; mouse.y = e.clientY - rect.top;
    });
  }

  function draw() {
    ctx.clearRect(0, 0, w, h);
    var g1 = ctx.createRadialGradient(w/2, h*0.42, 0, w/2, h*0.42, Math.min(w,h)*0.4);
    g1.addColorStop(0, 'rgba(212,175,55,0.07)');
    g1.addColorStop(0.4, 'rgba(212,175,55,0.03)');
    g1.addColorStop(1, 'rgba(212,175,55,0)');
    ctx.fillStyle = g1; ctx.fillRect(0, 0, w, h);

    ctx.save();
    ctx.globalAlpha = 0.015;
    for (var i = 0; i < 6; i++) {
      var angle = (Math.PI / 3) * i + Date.now() * 0.00003;
      var len = Math.min(w, h) * 0.6;
      ctx.beginPath();
      ctx.moveTo(w/2, h*0.42);
      ctx.lineTo(w/2 + Math.cos(angle) * len, h*0.42 + Math.sin(angle) * len);
      ctx.strokeStyle = '#d4af37'; ctx.lineWidth = 40; ctx.stroke();
    }
    ctx.restore();

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.x += p.vx; p.y += p.vy;
      p.pulse += p.pulseSpeed;
      if (p.x < -10) p.x = w + 10; if (p.x > w + 10) p.x = -10;
      if (p.y < -10) p.y = h + 10; if (p.y > h + 10) p.y = -10;

      var dx = mouse.x - p.x, dy = mouse.y - p.y;
      var dist = Math.sqrt(dx*dx + dy*dy);
      if (dist < 150) { p.vx -= dx * 0.00005; p.vy -= dy * 0.00005; }

      var alpha = p.baseAlpha + Math.sin(p.pulse) * 0.15;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(212,175,55,' + Math.max(0, alpha) + ')';
      ctx.fill();

      if (p.r > 1.2) {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 3, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(212,175,55,' + (alpha * 0.15) + ')';
        ctx.fill();
      }

      for (var j = i + 1; j < particles.length; j++) {
        var p2 = particles[j];
        var d = Math.sqrt((p.x - p2.x) * (p.x - p2.x) + (p.y - p2.y) * (p.y - p2.y));
        if (d < 120) {
          ctx.beginPath();
          ctx.moveTo(p.x, p.y); ctx.lineTo(p2.x, p2.y);
          ctx.strokeStyle = 'rgba(212,175,55,' + (0.06 * (1 - d/120)) + ')';
          ctx.lineWidth = 0.5; ctx.stroke();
        }
      }
    }
    requestAnimationFrame(draw);
  }

  init(); draw();
  window.addEventListener('resize', resize);
})();

/* ─── Scroll Reveal ─── */
(function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(function(el) { observer.observe(el); });
})();

/* ─── Smooth scroll ─── */
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.querySelector(this.getAttribute('href'));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
